import React from 'react';
import { Card } from '../ui/Card';
import { LockIcon, KeyIcon, RefreshCwIcon } from 'lucide-react';
export function OnlineLoginTab() {
  return <div data-id="element-394">
      <Card title="Online Account Access" data-id="element-395">
        <div className="flex items-center gap-3 mb-4" data-id="element-396">
          <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center" data-id="element-397">
            <LockIcon className="w-5 h-5 text-teal-600" data-id="element-398" />
          </div>
          <div data-id="element-399">
            <h3 className="font-medium" data-id="element-400">Account Enabled</h3>
            <p className="text-sm text-gray-500" data-id="element-401">
              Last login: October 15, 2023
            </p>
          </div>
        </div>
        <div className="space-y-4 mt-4" data-id="element-402">
          <div data-id="element-403">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-404">
              Username
            </label>
            <div className="flex gap-2" data-id="element-405">
              <input type="text" value="sarah.johnson" disabled className="flex-grow px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-gray-500" data-id="element-406" />
              <button className="px-3 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors" data-id="element-407">
                Edit
              </button>
            </div>
          </div>
          <div data-id="element-408">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-409">
              Password
            </label>
            <div className="flex gap-2" data-id="element-410">
              <input type="password" value="••••••••" disabled className="flex-grow px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-gray-500" data-id="element-411" />
              <button className="flex items-center gap-1 px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-412">
                <RefreshCwIcon className="w-4 h-4" data-id="element-413" />
                <span data-id="element-414">Reset</span>
              </button>
            </div>
          </div>
          <div className="flex gap-2 mt-6" data-id="element-415">
            <button className="flex items-center gap-1.5 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 transition-colors" data-id="element-416">
              <KeyIcon className="w-4 h-4" data-id="element-417" />
              <span data-id="element-418">Send Login Details</span>
            </button>
            <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-100 transition-colors" data-id="element-419">
              Disable Account
            </button>
          </div>
        </div>
      </Card>
    </div>;
}